module.exports = __webpack_public_path__ + "static/media/TUEV.e705aeef.png";